
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5F6368","fill-rule":"evenodd","d":"M15.388 14.578l-.315-.313a7.397 7.397 0 0 0 1.793-4.833A7.432 7.432 0 0 0 9.433 2a7.432 7.432 0 1 0 0 14.865 7.399 7.399 0 0 0 4.831-1.79l.316.312v.906L20.295 22 22 20.295l-5.704-5.717h-.908zm-5.955 0a5.145 5.145 0 1 1 0-10.291 5.145 5.145 0 0 1 0 10.29z"}})])
          )
        }
      }
    